import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import Settings from './Settings';
import api from './api'


export default (history) => combineReducers({
    router: connectRouter(history),
    settings: Settings,
    api
});
